import styled from 'styled-components';

import { colors, fonts, fontSizes } from 'shared/defaultTheme';

import { Modal } from '../modal/Modals';

const AlertModalWrapper = styled(Modal)`
  top: 20%;
  .modal-header {
    border: 0;
    border-radius: 0;
    svg {
      fill: ${colors.white};
    }
    .icon-title {
      height: 38px;
      width: 38px;
    }
    @-webkit-keyframes rotating {
      from {
        -webkit-transform: rotate(0deg);
      }
      to {
        -webkit-transform: rotate(360deg);
      }
    }
    .rotating {
      -webkit-animation: rotating 4s linear infinite;
    }
  }
`;

const Message = styled.div`
  color: ${colors.black};
  font-family: ${fonts.default};
  font-size: ${fontSizes.md}px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 22px;
`;

export { AlertModalWrapper, Message };
